/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	$stateProvider.state('entity', {
		abstract: true,
		parent: 'site',
	});
});
